import { Employment } from '../../models/employment';

export function getEmploymentSearchQuery(
  searchText: string,
): Mongo.Selector<Employment> {
  const partRegexes = searchText
    .split(' ')
    .filter((part) => !!part)
    .map((p) => ({
      $regex: p,
      $options: 'i',
    }));
  return {
    $and: partRegexes.map((partRegex) => ({
      $or: [
        { 'customer.displayName': partRegex },
        { 'department.name': partRegex },
        { 'department.costCenter': partRegex },
        { 'organisation.name': partRegex },
        { 'organisation.customerName': partRegex },
        { 'organisation.address.street': partRegex },
        { 'organisation.address.location': partRegex },
        { description: partRegex },
        { 'invitees.personalData.firstName': partRegex },
        { 'invitees.personalData.lastName': partRegex },
        { 'invitees.personalData.email': partRegex },
        { 'invitees.personalData.phone': partRegex },
      ],
    })),
  };
}
